
let products = [];

const fetchProducts = async (category = "all") => {
  
  const url =
    "https://app.jp-jewelrypart.com//web?material=" + category;
    
  try {
    const response = await fetch(url);
    const data = await response.json();

    if (category === "all" || category === "all products") {
      return data;
    }

    return data.filter((item) => item.material.toLowerCase() === category);
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

const fetchProductTypes = async (category = "all") => {
  const url = `https://app.jp-jewelrypart.com/web/bar?material=${category}`; //<---- link for catrgories hereeeee
  ;
  try {
    const response = await fetch(url);
    const types = await response.json();
    return types;
  } catch (error) {
    console.error("Error fetching product types:", error);
    return [];
  }
};

export { fetchProducts, fetchProductTypes };

export default products;
